module.exports = __webpack_public_path__ + "static/laptop-c1fc6f94da6b4fb1b2913cf117292427.jpg";